import { render } from "./DemoDashboard.vue?vue&type=template&id=31a9d033&scoped=true"
import script from "./DemoDashboard.vue?vue&type=script&lang=js"
export * from "./DemoDashboard.vue?vue&type=script&lang=js"

import "./DemoDashboard.vue?vue&type=style&index=0&id=31a9d033&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a9d033"]])

export default __exports__